module.exports = __webpack_public_path__ + "static/media/cuentas.f496cc9c.svg";